import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DialogService } from '../../services/dialog.service';

@Injectable({
  providedIn: 'root'
})
export class AdminLayoutService {

  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient,
    private dialogService: DialogService
  ) { }

  getUserList(obj: any) {
    let body = {
      client_key: obj.client_key,
      module_key: obj.module_key,
    };

    return this.apiService.post(environment.adminGetUserList, body);
  }

  getUserTypes() {
    return this.apiService.get(environment.adminGetUserTypes);
  }

  updateUserList(data: any): Observable<any> {
    
    if(this.apiService.getClientKey() && this.apiService.getEmpKey()) {
      let query: any = {
        "client_key": this.apiService.getClientKey(),
        "module_key": this.apiService.getModuleKey()
      }
      Object.assign(data, query)
    }
    // return this.apiService.post(environment.adminUpdateUserList, data);
    return this.httpClient.post(`${environment.apiBaseUrl}/${environment.adminUpdateUserList}`, data)
  }

  customSnackBars(message: any, action: any, color: any) {
    this.dialogService.customSnackBottomBar(message, action, color);
  }
}
